export const WHATSAPP_NUMBER = "905333200016";
export const WHATSAPP_LINK = "https://wa.me/905333200016";
export const PHONE_RAW = "+905333200016";
export const PHONE_DISPLAY = "+90 533 320 0016";

export const SECTION_IDS = {
  home: "home",
  about: "about",
  features: "features",
  masterplan: "masterplan",
  residence: "residence",
  location: "location",
  plans: "plans",
  gallery: "gallery",
  investment: "investment",
  contact: "contact",
};

export const NAV_KEYS = [
  "home",
  "about",
  "features",
  "masterplan",
  "residence",
  "location",
  "plans",
  "gallery",
  "contact",
];
